/**
 * Utility functions for dialogs
 */

/**
 * CSS classes to make a dialog content scrollable
 * This can be used in any DialogContent component to ensure it's scrollable
 * when the content is too long
 */
export const scrollableDialogContentClass = "max-h-[80vh] overflow-y-auto";